module.exports = __webpack_public_path__ + "media/images/screens/11_Panier-982c0420a8e4722e6e48a9d50c393007.jpg";